"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var util_1 = require("./util");
var useScroll = function (ref) {
    var frame = react_1.useRef(0);
    var _a = react_1.useState({
        x: util_1.isClient ? window.scrollX : 0,
        y: util_1.isClient ? window.scrollY : 0
    }), state = _a[0], setState = _a[1];
    react_1.useEffect(function () {
        var handler = function () {
            cancelAnimationFrame(frame.current);
            frame.current = requestAnimationFrame(function () {
                setState({
                    x: ref.current.scrollLeft,
                    y: ref.current.scrollTop
                });
            });
        };
        if (ref && ref.current) {
            ref.current.addEventListener('scroll', handler, {
                capture: false,
                passive: true
            });
        }
        return function () {
            if (frame.current) {
                cancelAnimationFrame(frame.current);
            }
            if (ref && ref.current) {
                ref.current.removeEventListener('scroll', handler);
            }
        };
    }, [ref]);
    return state;
};
exports.default = useScroll;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/lib/useScroll.js
// module id = 1230
// module chunks = 17